import { useQueryClient, useQuery } from "@tanstack/react-query";
import { FileThumbnail, FileThumbnails } from "types";
import { axiosBeyonClient } from "utils/beyonAuth/beyonAxiosClient";

export function useThumbnails(workspaceId: string, fileIds: string[]) {

    const queryClient = useQueryClient();

    return useQuery({
        queryKey: ['thumbnails', fileIds],
        queryFn: async () => {
            const missingIds = fileIds.filter((id) => {
                return !queryClient.getQueryData(['thumbnail', id]);
            });

            if (missingIds.length === 0) {
                return fileIds.map((id) => queryClient.getQueryData<FileThumbnails>(['thumbnail', id]));
            }

            const { data: newData } = await axiosBeyonClient.post<FileThumbnails[]>(`workspace/${workspaceId}/thumbnails`, missingIds);

            newData.forEach((item) => {
                queryClient.setQueryData(['thumbnail', item.fileId], item);
            });

            return fileIds.map((id) => {
                return queryClient.getQueryData<FileThumbnails>(['thumbnail', id]);
            });
        },
        enabled: fileIds.length > 0
    });
}


export function defaultThumbnails(fileHref: string): FileThumbnail[] {
    return [
        {
            type: "tile",
            href: fileHref
        },
        {
            type: "preview",
            href: fileHref
        }
    ];
}